var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "special-code" }, [
    _c(
      "div",
      { staticClass: "special-code-header" },
      [
        _c(
          "header-close",
          { attrs: { deactivate: _vm.deactivate, back: _vm.back } },
          [_vm._v(_vm._s(_vm.tc("booking.specialCode")) + "\n    ")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "special-code-content" }, [
      _c("form", { staticClass: "form" }, [
        _c("fieldset", { staticStyle: { padding: "0" } }, [
          _c("legend", { staticClass: "sr-only" }, [
            _vm._v(_vm._s(_vm.tc("booking.specialCode"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "fields-wrapper" }, [
            _c("div", { staticClass: "input dropdown specialCodeType" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.specialCodeType,
                      expression: "specialCodeType",
                    },
                  ],
                  attrs: {
                    id: "specialCodeType",
                    name: "specialCodeType",
                    "data-field-type": "DropdownList",
                  },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.specialCodeType = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "" } }),
                  _vm._v(" "),
                  !_vm.isBookingEditMode
                    ? _c("option", { attrs: { value: "iataNumber" } }, [
                        _vm._v(_vm._s(_vm.tc("formFields.iataNumber"))),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "promotionCode" } }, [
                    _vm._v(_vm._s(_vm.tc("formFields.promoCode"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "groupCode" } }, [
                    _vm._v(_vm._s(_vm.tc("formFields.groupCode"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "floating", attrs: { for: "specialCodeType" } },
                [_vm._v(_vm._s(_vm.tc("formFields.codeType")))]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input specialCodeInput" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.specialCodeValue,
                    expression: "specialCodeValue",
                  },
                ],
                class: [
                  { "no-value": !_vm.specialCodeValue },
                  { "has-value": _vm.specialCodeValue },
                  { valid: !!_vm.specialCodeValue },
                  { "input-validation-error": _vm.employeePromosError },
                ],
                attrs: {
                  type: "text",
                  id: "specialCodeInput",
                  name: "specialCodeInput",
                  "data-field-type": "SingleLineText",
                },
                domProps: { value: _vm.specialCodeValue },
                on: {
                  keypress: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.submit($event)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "space", 32, $event.key, [
                          " ",
                          "Spacebar",
                        ])
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.submit($event)
                    },
                  ],
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.specialCodeValue = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "floating", attrs: { for: "specialCodeInput" } },
                [_vm._v(_vm._s(_vm.tc("formFields.enterSpecialCode")))]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "button-wrapper" }, [
              _c(
                "button",
                {
                  staticClass: "special-code-apply",
                  class: {
                    "special-code-apply_disabled":
                      !_vm.specialCodeType || !_vm.specialCodeValue,
                  },
                  attrs: {
                    "aria-disabled":
                      !_vm.specialCodeType || !_vm.specialCodeValue,
                    "aria-label":
                      _vm.tc("booking.apply") +
                      " " +
                      _vm.tc("booking.specialCode"),
                    tabindex: "0",
                    type: "button",
                  },
                  on: {
                    click: function ($event) {
                      !_vm.specialCodeType || !_vm.specialCodeValue
                        ? null
                        : _vm.submit()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.tc("booking.apply")) +
                      "\n            "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.employeePromosError
        ? _c("div", { staticClass: "special-code-error-box" }, [
            _c("span", { staticClass: "special-code-error-message" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.tc("errors.promoCodeOnlyLoggedUser")) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            !_vm.user
              ? _c(
                  "div",
                  { staticClass: "special-code-signin" },
                  [
                    _c("auth-activator", {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var activate = ref.activate
                              return [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return activate("login", $event.target)
                                      },
                                      keydown: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "space",
                                            32,
                                            $event.key,
                                            [" ", "Spacebar"]
                                          )
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                        return activate("login", $event.target)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.tc("auth.signIn")) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3694477708
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }